<template>
<v-app>
  <form>
    <v-card>
      <v-card-title>
        <span class="headline" v-if="!plan.id">New plan</span>
        <v-layout v-if="plan.id" column ma-0>
          <span class="headline">Edit "{{plan.name.en}}"</span>
          <span style="font-size: 16px">{{ plan.id }}</span>
        </v-layout>
        <v-spacer></v-spacer>
        <v-btn text icon @click="hideModal">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-tabs color="#EEE" v-model="currentTab" centered>
          <v-tabs-slider color="blue"></v-tabs-slider>
          <v-tab key="1" href="#tab-1">General</v-tab>
          <v-tab key="2" href="#tab-2">Business</v-tab>
          <v-tab key="3" href="#tab-3">Content</v-tab>
          <v-tab key="4" href="#tab-4">French</v-tab>

          <v-tabs-items v-model="currentTab">
            <v-tab-item key="1" value="tab-1">
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field
                      label="Plan Name*"
                      v-model.trim="plan.name.en"
                      v-validate="'required'"
                      :error-messages="errors.collect('plan name')"
                      data-vv-name="plan name"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      label="Plan title*"
                      v-model.trim="plan.title.en"
                      v-validate="{required: false}"
                      :error-messages="errors.collect('plan title')"
                      data-vv-name="plan title"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      label="Code*"
                      v-model.trim="plan.code"
                      v-validate="'required|alpha_dash'"
                      :error-messages="errors.collect('plan code')"
                      data-vv-name="plan code"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      label="Front Group ID*"
                      v-model.trim="plan.front_group_id"
                      v-validate="'required|alpha_dash'"
                      :error-messages="errors.collect('front group ID')"
                      data-vv-name="front group ID"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-tab-item>
            <v-tab-item key="2" value="tab-2">
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-autocomplete
                      v-model="business"
                      :loading="loading"
                      :items="businessList"
                      :search-input.sync="search"
                      v-validate="'required'"
                      :error-messages="errors.collect('business')"
                      data-vv-name="business"
                      clearable
                      item-text="name"
                      item-value="id"
                      text
                      :label="label"
                    >
                      <template v-slot:selection="data">
                        <span>{{ data.item.name }}</span>
                      </template>
                      <template v-slot:no-data>
                        <v-list-item>
                          <v-list-item-title>Search for a business associated with this plan*</v-list-item-title>
                        </v-list-item>
                      </template>
                      <template v-slot:item="{ item }">
                        <v-list-item-content>
                          <v-list-item-title v-text="item.name"></v-list-item-title>
                          <v-list-item-subtitle v-text="item.code"></v-list-item-subtitle>
                        </v-list-item-content>
                      </template>
                    </v-autocomplete>
                  </v-flex>
                  <v-flex xs4>
                    <v-text-field
                      label="Price*"
                      hint="in cents"
                      v-model.trim="plan.price"
                      append-icon="euros"
                      v-validate="'required|numeric|min_value:0|max_value:100000'"
                      :error-messages="errors.collect('plan price')"
                      data-vv-name="plan price"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4>
                    <v-select
                      :items="intervals"
                      label="Interval*"
                      item-text="name"
                      item-value="value"
                      v-model.trim="plan.interval"
                      v-validate="'required'"
                      :error-messages="errors.collect('plan interval')"
                      data-vv-name="plan interval"
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex xs4>
                    <v-text-field
                      label="Trial period (in days)*"
                      v-model.trim="plan.trial"
                      v-validate="'required|numeric|min_value:0|max_value:365'"
                      :error-messages="errors.collect('plan trial')"
                      data-vv-name="plan trial"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-switch v-model="plan.is_active" label="Is active?"></v-switch>
                  </v-flex>
                  <v-flex xs6>
                    <v-switch
                      v-model="plan.can_be_switched"
                      color="indigo"
                      label="Can be switched?"
                    ></v-switch>
                  </v-flex>
                  <v-flex xs6>
                    <v-switch v-model="plan.is_paid" label="Is paid plan?"></v-switch>
                  </v-flex>
                  <v-flex xs6>
                    <v-switch v-model="plan.has_vat" color="indigo" label="VAT included?"></v-switch>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                      label="Vat amount (%)*"
                      hint="in cents"
                      :disabled="!plan.has_vat"
                      v-model.trim="plan.vat_amount"
                      append-icon="euros"
                      v-validate="'decimal:2|min_value:0|max_value:100'"
                      :error-messages="errors.collect('vat amount')"
                      data-vv-name="vat amount"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                      label="User's initial amount"
                      hint="in cents"
                      v-model.trim="plan.initial_amount"
                      append-icon="euros"
                      v-validate="'numeric|min_value:0|max_value:100'"
                      :error-messages="errors.collect('initial amount')"
                      data-vv-name="initial amount"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                      label="User's initial coupon"
                      v-model.trim="plan.coupon"
                      v-validate="'alpha_num|min:8'"
                      :error-messages="errors.collect('initial coupon')"
                      data-vv-name="initial coupon"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-tab-item>
            <v-tab-item key="3" value="tab-3">
              <v-container grid-list-md>
                <v-layout row>
                  <v-flex xs12 sm6>
                    <img
                      alt="Thumbnail"
                      :src="plan.image.public_url"
                      v-if="plan.image"
                      width="100"
                      height="auto"
                    />
                  </v-flex>
                  <v-flex xs12 sm6>
                    <file-upload
                      :file-name="`plan-${plan.id}`"
                      :file-path="`business_images/plans`"
                      v-model="plan.image"
                    ></file-upload>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex xs12 sm12>
                    <span style="color: rgba(0, 0, 0, 0.54)">Content (can be HTML)*</span>
                    <vue-editor v-model="plan.content.en" :editorToolbar="customToolbar"></vue-editor>
                  </v-flex>
                  <v-flex xs12 sm12>
                    <v-list-item>These are the plan's perks:</v-list-item>
                    <v-combobox
                      v-model="perksEn"
                      :filter="perksFilter"
                      :hide-no-data="!perksSearch"
                      :items="perkDefaults.en"
                      :search-input.sync="perksSearch"
                      ref="planPerksEn"
                      @blur="closeSelect('planPerksEn')"
                      label="Search for an option"
                      hide-selected
                      multiple
                      small-chips
                      solo
                    >
                      <template v-slot:no-data>
                        <v-list-item>
                          <span class="subheading">Create</span>
                          <v-chip color="green lighten-3" label small>{{ perksSearch }}</v-chip>
                        </v-list-item>
                      </template>
                      <template v-slot:selection="{ item, parent, selected }">
                        <v-chip color="green lighten-3" :input-value="selected" label small>
                          <span class="pr-2" v-html="item"></span>
                          <v-icon small @click="parent.selectItem(item)">close</v-icon>
                        </v-chip>
                      </template>
                      <template v-slot:item="{ index, item }">
                        <v-list-item-content>
                          <v-text-field
                            v-if="editing === item"
                            v-model="editing"
                            autofocus
                            text
                            background-color="transparent"
                            hide-details
                            solo
                            @keyup.enter="editPerk(index, item)"
                          ></v-text-field>
                          <v-chip v-else color="green lighten-3" dark label small>{{ item }}</v-chip>
                        </v-list-item-content>
                        <v-spacer></v-spacer>
                      </template>
                    </v-combobox>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-tab-item>
            <v-tab-item key="4" value="tab-4">
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm12>
                    <span
                      style="font-size: 18px"
                      class="grey--text"
                    >Only used when the Business is not French by default.</span>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      label="French plan name*"
                      v-model.trim="plan.name.fr"
                      :error-messages="errors.collect('french plan name')"
                      data-vv-name="french plan name"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      label="French plan title*"
                      v-model.trim="plan.title.fr"
                      :error-messages="errors.collect('french plan title')"
                      data-vv-name="french plan title"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12>
                    <v-textarea
                      v-model="plan.content.fr"
                      auto-grow
                      color="deep-purple"
                      label="French content (can be HTML)*"
                      rows="4"
                    ></v-textarea>
                  </v-flex>
                  <v-flex xs12 sm12>
                    <v-list-item>These are the plan's perks in French:</v-list-item>
                    <v-combobox
                      v-model="perksFr"
                      :filter="perksFilter"
                      :hide-no-data="!perksSearch"
                      :items="perkDefaults.fr"
                      :search-input.sync="perksSearch"
                      ref="planPerksFr"
                      @blur="closeSelect('planPerksFr')"
                      label="Search for an option"
                      hide-selected
                      multiple
                      small-chips
                      solo
                    >
                      <template v-slot:no-data>
                        <v-list-item>
                          <span class="subheading">Create</span>
                          <v-chip color="green lighten-3" label small>{{ perksSearch }}</v-chip>
                        </v-list-item>
                      </template>
                      <template v-slot:selection="{ item, parent, selected }">
                        <v-chip color="green lighten-3" :input-value="selected" label small>
                          <span class="pr-2">{{ item }}</span>
                          <v-icon small @click="parent.selectItem(item)">close</v-icon>
                        </v-chip>
                      </template>
                      <template v-slot:item="{ index, item }">
                        <v-list-item-content>
                          <v-text-field
                            v-if="editing === item"
                            v-model="editing"
                            autofocus
                            text
                            background-color="transparent"
                            hide-details
                            solo
                            @keyup.enter="editPerk(index, item)"
                          ></v-text-field>
                          <v-chip v-else color="green lighten-3" dark label small>{{ item }}</v-chip>
                        </v-list-item-content>
                        <v-spacer></v-spacer>
                      </template>
                    </v-combobox>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <small>*indicates required field</small>
        <v-spacer></v-spacer>
        <v-btn text outlined @click="hideModal">Close</v-btn>
        <v-btn color="success" outlined @click="savePlan">Save</v-btn>
      </v-card-actions>
    </v-card>
  </form>
</v-app>
</template>

<script>
import fb from "@/firebase";
import { mapState, mapMutations } from "vuex";
import { VueEditor } from "vue2-editor";

import FileUpload from "@/components/FileUpload";

const plans = fb.db.collection("business_plans");

export default {
  name: "PlanForm",
  components: {
    VueEditor,
    FileUpload
  },
  props: {
    plan: Object
  },
  data: () => ({
    loading: false,
    businessList: [],
    businessId: null,
    perksEn: [],
    perksFr: [],
    search: null,
    currentTab: "tab-1",
    perkDefaults: {
      en: [
        "Your dedicated number by webchat and SMS.",
        "Our personal assistants <strong>at your service</strong>.",
        "No service markups for orders under 100€.",
        "Your service <strong>7/7</strong>.",
        "Unlimited <strong>service time</strong>.",
        "<strong>Promotional offers</strong> every month."
      ],
      fr: [
        "Votre numéro dédié, par webchat, app mobile ou SMS.",
        "Des concierges <strong>à votre écoute</strong>.",
        "Aucun frais de service.",
        "Service <strong>accessible 7j/7</strong>.",
        "Réservations <strong>illimitées</strong>.",
        "Des <strong>offres promotionnelles</strong> chaque mois."
      ]
    },
    perksSearch: null,
    activator: null,
    attach: null,
    editing: null,
    index: -1,
    nonce: 1,
    menu: false,
    x: 0,
    y: 0,
    label: "Please select a business*",
    intervals: [
      {
        value: "month",
        name: "Monthly"
      },
      {
        value: "year",
        name: "Yearly"
      }
    ],
    customToolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["code-block"]
    ]
  }),
  computed: {
    ...mapState({
      businesses: "businesses",
      planList: "plans"
    }),
    business: {
      get: function() {
        if (this.businessId) {
          return this.businessId;
        } else {
          return this.plan.business;
        }
      },
      set: function(newValue) {
        this.businessId = newValue;
      }
    }
  },
  firestore: {
    plans: plans
  },
  watch: {
    search(val) {
      val && val !== this.plan.business && this.querySelections(val);
    },
    plan: {
      handler: function(val) {
        this.businessList = this.businesses;
        if (parseInt(val.price) > 0) {
          this.plan.is_paid = true;
        }
        if (val.perks.en) {
          this.perksEn = val.perks.en;
        } else {
          this.perksEn = [];
        }
        if (val.perks.fr) {
          this.perksFr = val.perks.fr;
        } else {
          this.perksFr = [];
        }
        if (!val.api_country_code) {
          this.plan.api_country_code = "FR";
        }
      },
      immediate: true
    },
    perksEn(val, prev) {
      if (val.length === prev.length) return;

      this.perksEn = val.map(v => {
        this.perkDefaults.en.push(v);

        this.nonce++;

        return v;
      });
    },
    perksFr(val, prev) {
      if (val.length === prev.length) return;

      this.perksFr = val.map(v => {
        this.perkDefaults.fr.push(v);

        this.nonce++;

        return v;
      });
    }
  },
  mounted() {},
  methods: {
    ...mapMutations(["setAppAlert"]),
    closeSelect(name) {
      console.log("Close select: ", name);
      this.$refs[name].blur();
    },
    querySelections(v) {
      this.loading = true;
      this.businessList = this.businesses.filter(e => {
        if (
          (e.name || "").toLowerCase().indexOf((v || "").toLowerCase()) > -1
        ) {
          return e.id;
        }
      });
      this.loading = false;
    },
    savePlan() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.plan.created = this.plan.created
            ? this.plan.created
            : Date.now();
          this.plan.perks.en = this.perksEn;
          this.plan.perks.fr = this.perksFr;
          if (!this.plan.id) {
            this.plan.business = this.businessId;
            plans
              .add(this.plan)
              .then(doc => {
                this.planList.push({ id: doc.id, code: this.plan.code });
                plans.doc(doc.id).update({ id: doc.id });
                this.setAppAlert({
                  visible: true,
                  text: "The plan has been created",
                  color: "success"
                });
                this.hideModal();
              })
              .catch(error => {
                this.setAppAlert({
                  visible: true,
                  text: error.message
                });
              });
          } else {
            if (this.businessId) {
              this.plan.business = this.businessId;
            }
            plans
              .doc(this.plan.id)
              .update(this.plan)
              .then(() => {
                let id = this.plan.id;
                let planIndex = this.planList.findIndex(function(element) {
                  return element.id === id;
                });
                if (this.planList[planIndex].code !== this.plan.code) {
                  this.planList[planIndex].code = this.plan.code;
                }
                this.setAppAlert({
                  visible: true,
                  text: "The plan has been updated",
                  color: "success"
                });
                this.hideModal();
              })
              .catch(error => {
                this.setAppAlert({
                  visible: true,
                  text: error.message
                });
              });
          }
          return;
        } else {
          this.setAppAlert({
            visible: true,
            text: "Some required fields are incomplete or invalid",
            color: "error"
          });
        }
      });
    },
    hideModal() {
      //this.offer.name = "";
      //this.offer.frontChannelId = "";
      this.$emit("close");
    },
    editPerk(index, item) {
      if (!this.editing) {
        this.editing = item;
        this.index = index;
      } else {
        this.editing = null;
        this.index = -1;
      }
    },
    perksFilter(item, queryText, itemText) {
      if (item.header) return false;

      const hasValue = val => (val != null ? val : "");

      const text = hasValue(itemText);
      const query = hasValue(queryText);

      return (
        text
          .toString()
          .toLowerCase()
          .indexOf(query.toString().toLowerCase()) > -1
      );
    }
  }
};
</script>
